@if(dataSignal(); as data){
<div class="grid-product">
  <div class="img-relative">
    @if(data.image_a){
    <img
      [src]="replaceBucket.replaceBucket(data.image_a)"
      [alt]="data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating"
      class="img-container img-layout"
      [title]="
        data.name + ' ' + data.tire_width + '/' + data.tire_height + 'R' + data.tire_size + ' ' + data.load_index + data.speed_rating
      "
      loading="lazy"
    />
    @if(data.badge) { @if(data.badge.includes('new')) {
    <img
      class="badge-layout"
      src="assets/icons/icon-new-badge.png"
      alt="ไอคอนสำหรับยางตัวใหม่"
      title="ไอคอนสำหรับยางตัวใหม่"
      loading="lazy"
    />
    } @else if (data.badge.includes('hot')) {
    <img
      class="badge-layout"
      src="assets/icons/icon-hot-badge.png"
      alt="ไอคอนสำหรับยางยอดนิยม"
      title="ไอคอนสำหรับยางยอดนิยม"
      loading="lazy"
    />
    } @if(data.badge.includes('ev')) {
    <img
      class="badge-layout-ev"
      src="assets/icons/icon-ev-badge.png"
      alt="ไอคอนสำหรับยางไฟฟ้า"
      title="ไอคอนสำหรับยางไฟฟ้า"
      loading="lazy"
    />
    } } }
  </div>
  <div class="flex-product flex-product-direction minHeight-400">
    <!-- class="flex-product" -->
    <div [ngClass]="productTypeSignal() ? 'flex-product' : 'flex-product-none-tire '">
      <div>
        <img
          class="logo-product"
          [src]="replaceBucket.replaceBucket(data.brand_image)"
          [alt]="data.brand_name"
          [title]="data.brand_name"
          loading="lazy"
        />
      </div>
      <h2 class="font-size-34 font-weight-bold">{{ data.name }}</h2>
    </div>
    <div>
      @if (productTypeSignal()){
      <span class="font-size-20 font-weight-medium tire-size">
        {{ data.tire_width }}/{{ data.tire_height }}R{{ data.tire_size }} {{ data.load_index }}{{ data.speed_rating }}
      </span>
      }@else {
      <div class="font-size-20 font-weight-medium">ประเภท : {{ data.attr_product_a }}</div>
      }
    </div>
    @if (productTypeSignal()) {
    <section class="gauge product-rate">
      <ul>
        @if(data.perf_a){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_a"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_a }}/10</span>
          </div>
          }
          <span>การยึดเกาะบนถนนแห้ง</span>
        </li>
        } @if(data.perf_b){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_b"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_b }}/10</span>
          </div>
          }
          <span>การยึดเกาะบนถนนเปียก</span>
        </li>
        } @if(data.perf_c){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_c"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_c }}/10</span>
          </div>
          }
          <span>อายุการใช้งาน</span>
        </li>
        } @if(data.perf_d){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_d"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_d }}/10</span>
          </div>
          }
          <span>ความนุ่มนวล</span>
        </li>
        } @if(data.perf_e){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_e"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_e }}/10</span>
          </div>
          }
          <span>ความเงียบในห้องโดยสาร</span>
        </li>
        } @if(data.perf_f){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_f"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_f }}/10</span>
          </div>
          }
          <span>ความต้านทานการหมุน</span>
        </li>
        } @if(data.perf_g){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_g"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_g }}/10</span>
          </div>
          }
          <span>แรงกรุยบนถนนขรุขระ</span>
        </li>
        } @if(data.perf_h){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_h"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_h }}/10</span>
          </div>
          }
          <span>การหยุดรถ</span>
        </li>
        } @if(data.perf_i){
        <li>
          @defer (on viewport) {
          <ngx-gauge
            [type]="gaugeType"
            [value]="data.perf_i"
            [min]="0"
            [max]="10"
            [thick]="gaugeThick()"
            [size]="gaugeSize()"
            foregroundColor="#0753A8"
          ></ngx-gauge>
          } @placeholder {
          <div class="gauge-placeholder" [style.width.px]="gaugeSize()" [style.height.px]="gaugeSize()">
            <span class="gauge-value">{{ data.perf_i }}/10</span>
          </div>
          }
          <span>การควบคุมตัวรถ</span>
        </li>
        }
      </ul>
    </section>
    }@else {
    <p class="font-size-14 font-weight-regular text-description">{{ data.short_description }}</p>
    }

    <div class="flex-product flex-product-justify-content margin-top-end">
      <div class="flex-price price">
        <span class="font-size-14 price font-weight-bold text-price-label">ราคา</span>
        <span class="font-size-28 price font-weight-bold" itemprop="price">{{ data.price | number }} บาท</span>
      </div>

      <div class="flex-group-botton">
        <a class="themeDetailButton1" mat-flat-button [routerLink]="getProductDetailRoute(data.id)">ดูรายละเอียด</a>

        <a class="themeDetailButton2" mat-flat-button [routerLink]="getProductDetailRoute(data.id)">ดูรายละเอียด</a>

        @if (productTypeSignal()){
        <button class="themeCompareProductButton1" mat-flat-button (click)="addToComparison(data)">
          <span class="xl-mr-l-1">+ เปรียบเทียบ</span>
        </button>

        <button class="themeCompareProductButton2" mat-fab (click)="addToComparison(data)">
          <mat-icon class="mat-add-icon">add</mat-icon>
        </button>
        }
      </div>
    </div>
  </div>
</div>
}
